export default theme => {
  return {
    container: {
      padding: 5
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/configuration/ComcastV2/theme/components/scorecard/ScorecardView/ScorecardHeader.js